var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-body"},[_vm._v("\n\n    Will be enabled soon\n    ")])
}
var staticRenderFns = []

export { render, staticRenderFns }